// extracted by mini-css-extract-plugin
export default {"PasswordResetEmailForm__submit":"yq_a bhf_qj bhf_to"};